import "./index.scss";
import { useEffect, useState } from "react";
import { hasDecimal,performOperation } from "../../utils/helper_functions";

function Calculator() {
    const [displayString, setDisplayString] = useState("0");
    const [currentVal, setCurrentVal] = useState(null);
    const [currentOp, setCurrentOp] = useState(null);
    const [prevOp,setPrevOp] = useState(null);


    const calculateResult = () => {
        let displayNum = parseFloat(displayString)
        let result = performOperation(currentOp,currentVal,displayNum);
        setCurrentVal(result);
        setDisplayString("" + result);
    }
    
  
    const handleOperatorClick = (operatorName) => {
      console.log("Handling operation: " + operatorName);
  
      if(operatorName === "equals"){
  
        if(currentOp === null){
          return;
        }
  
        let displayNum = parseFloat(displayString)
        let result = performOperation(currentOp,currentVal,displayNum);
        setCurrentVal(result);
        setDisplayString("" + result);
        setCurrentOp(null);
        setPrevOp(null);
        return;
      }

      if(prevOp !== null && currentVal !== null){
        console.log("Calculating result in handleOperatorClick")
        calculateResult();
        setPrevOp(null);
        setCurrentOp(null);

      }
  
      setCurrentOp(operatorName);
  
     
    
        
    }
  
    const addSign = () => {
      if(displayString.startsWith("-")){
        setDisplayString(displayString.substring(1,displayString.length));
      } else if(displayString !== "0") {
        setDisplayString("-" + displayString);
      }
    }
  
    const convertToPercent = () => {
      let displayVal = parseFloat(displayString);
      let newVal = displayVal/100;
      setDisplayString(newVal);
    }
  
    const addDecimal = () => {
      if(!hasDecimal(displayString)){
        if(prevOp !== currentOp){
          setDisplayString("0.");
          setCurrentVal(currentVal + parseFloat(displayString));
          setPrevOp(currentOp);
              
        } else {
          setDisplayString(displayString + ".")
        }

        
      }
    }
  
    const handleNumberClick = (number) => {
  
      if(prevOp !== currentOp){

       
  
        setPrevOp(currentOp);
        setCurrentVal(parseFloat(displayString));
        setDisplayString(number.toString());
       
        
      }else if(displayString === "0"){
       
        setDisplayString(number.toString())
       
     
      } else{
        setDisplayString(displayString + number.toString());
        
      }
  
    }
  
    const handleClear = () => {
      setDisplayString("0");
      setCurrentVal(null);
      setCurrentOp(null);
      setPrevOp(null);
    }
  
    let displayStyleBigString = {
      fontSize: `${30/displayString.length}vw`
    }
  
    let displayStyleRegular = {
      fontSize: "30px"
    }
  
    let displayStringStyle = displayString.length < 16 ? displayStyleRegular : displayStyleBigString;
  
    return (
      <div className="wrapper">
        <div className="calculator">
            <div style={displayStringStyle} className="display">{displayString}</div>
            <div className="number-pad">
                <div onClick={handleClear} className="pad-button">A/C</div>
                <div onClick={addSign} className="pad-button">+/-</div>
                <div onClick={convertToPercent} className="pad-button">%</div>
                <div onClick={() => {handleOperatorClick("divide")}} className="pad-button">&#247;</div>
  
                <div onClick={() => { handleNumberClick(1)}} className="pad-button">1</div>
                <div onClick={() => { handleNumberClick(2)}} className="pad-button">2</div>
                <div onClick={() => { handleNumberClick(3)}} className="pad-button">3</div>
                <div onClick={() => {handleOperatorClick("multiply")}} className="pad-button">x</div>
  
                <div onClick={() => { handleNumberClick(4)}} className="pad-button">4</div>
                <div onClick={() => { handleNumberClick(5)}} className="pad-button">5</div>
                <div onClick={() => { handleNumberClick(6)}} className="pad-button">6</div>
                <div onClick={() => {handleOperatorClick("subtract")}} className="pad-button">-</div>
  
                <div onClick={() => { handleNumberClick(7)}} className="pad-button">7</div>
                <div onClick={() => { handleNumberClick(8)}} className="pad-button">8</div>
                <div onClick={() => { handleNumberClick(9)}} className="pad-button">9</div>
                <div onClick={() => {handleOperatorClick("add")}} className="pad-button">+</div>
  
                <div onClick={() => { handleNumberClick(0)}} className="pad-button zero-button">0</div>
                <div onClick={addDecimal} className="pad-button">.</div>
                <div onClick={() => {handleOperatorClick("equals")}} className="pad-button">=</div>
            </div>
        </div>
      </div>
    );
  }
  
  export default Calculator;
  
